<template>
    <div>
        <v-card elevation="0" outlined class="mb-4">
            <v-card-title class="justify-center">Tanulmányi előrehaladás</v-card-title>
            <v-card-text>
                <div class="main-chart">
                    <v-tooltip v-for="(type, typeKey) in calculateTypes.slice(0, -1)" :key="typeKey" top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on" :style="{
                                height: '100%',
                                width: animated
                                    ? (type.done / calculateTypes[calculateTypes.length - 1].all * 100) + '%'
                                    : '0%',
                                transition: 'width 1s ease-in ' + (100 + typeKey * 150) + 'ms',
                                background: colors[typeKey % colors.length],
                                overflow: 'hidden',
                                borderRadius: typeKey === 0
                                    ? '5px 0 0 5px'
                                    : typeKey === calculateTypes.length - 2
                                        ? '0 5px 5px 0'
                                        : '0'
                            }">
                            </div>
                        </template>
                        <span v-if="type.type == 0">{{ type.name }}: {{ type.done }} / {{ type.all }}</span>
                        <span v-else>{{ type.name }}: {{ type.done / 4}} / {{ type.all / 4 }}</span>
                    </v-tooltip>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "Chart",
    props: {
        types: Array
    },
    data: () => ({
        animated: false,
        colors: [
            "#00838F",
            "#00ACC1",
            "#00BCD4",
            "#4DB6AC",
            "#26A69A",
            "#00897B",
            "#43A047",
            "#66BB6A",
            "#81C784",
            "#1565C0",
            "#1976D2",
            "#42A5F5",
            "#5C6BC0",
            "#546E7A",
            "#78909C",
        ]
    }),

    watch: {
        types: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.animated = false
                    setTimeout(() => {
                        this.animated = true
                    }, 100)
                }
            },
            immediate: true
        }
    },

    computed: {
        calculateTypes() {
            let types = [];
            this.types.forEach(element => {
                let all = 0;
                let done = 0;
                let type = 0
                if (element.credit && !element.tantargyak_szama) {
                    all = parseInt(element.credit) || 0;
                    element.subjects.forEach(sub => {
                        if (sub.done) {
                            done += parseInt(sub.Targy_kredit) || 0;
                        }
                    })
                    type = 0;
                } else if (!element.credit && element.tantargyak_szama) {
                    all = parseInt(element.tantargyak_szama) * 4 || 0;
                    element.subjects.forEach(sub => {
                        if (sub.done) {
                            done += 4;
                        }
                    })
                    type = 1;
                }
                types.push({ name: element.name, all, done, type: type });
            });

            let summary = { all: 0 };
            types.forEach(item => { summary.all += item.all; })
            types.push(summary);
            return types;
        }
    }
};
</script>

<style>
.main-chart {
    width: 100%;
    height: 2rem;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    display: flex;
}
</style>
